import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import nullBind from 'utils/functions/nullBind.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';
import actionType from 'utils/mw/actionType.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';
import clampOrMin from 'utils/values/clampOrMin.util';

const L = logger('actionBe');

const MIN_VER = 3;
const MAX_VER = Number.MAX_SAFE_INTEGER;

const clamp = nullBind(clampOrMin, MIN_VER, MAX_VER);

const actionBe = (ATAG, fn) => {
  const AT = actionType(ATAG);
  const type = fromAnyToTrimmed(AT.name);

  if (!type) L.error('()', 'Invalid action type:', type);
  if (isNotFn(fn)) L.error('()', 'Invalid function fn:', fn);

  // using this indirect approach as to let the JS engine give our desired name to the new function
  const temporary = {};
  const functionName = `actionBe(${fromAnyToTrimmed(ATAG) || 'Unknown'})`;

  temporary[functionName] = (options) => {
    // actionBe means using the newer middleware, at or above MIN_VER

    const optionsVersion = clamp(options.v);
    const result = fn({ ...options, AT, ATAG, L: logger(ATAG), v: optionsVersion });
    const resultVersion = clamp(result.v);

    return Object.freeze({ ...result, v: resultVersion });
  };

  Object.defineProperty(temporary[functionName], 'name', { value: functionName });

  return Object.assign(withOptions(temporary[functionName]), { AT, ATAG });
};

// noinspection JSUnusedGlobalSymbols
export default actionBe;
